import {
    tns
} from 'tiny-slider/src/tiny-slider';
var sliders = {};
export const start = async function() {
    await setTimeout(async () => {
        var slider = tns({
            container: '.base-infinity',
            slideBy: 1,
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 2500,
            speed: 2400,
            center: true,
            swipeAngle: false,
            loop: true,
            controls: false,
            items: 3,
            gutter: 40,
            edgePadding: 100,
            responsive: {
                360: {
                    items: 1,
                    gutter: 20,
                    edgePadding: 40
                },
                768: {
                    items: 3,
                    gutter: 40,
                    edgePadding: 50
                },
                992: {
                    items: 3,
                    gutter: 40,
                    edgePadding: 60
                },
                1199: {
                    items: 3,
                    gutter: 40,
                    edgePadding: 100
                }
            }
        });
        sliders = slider;
        //

        const arrowCont = Array.from(document.getElementsByClassName('arrowContainer-infinity'))
        arrowCont.forEach((element, i) => {
            element.addEventListener('mousemove', e => cursorPosition(e, element, slider, i, arrowCont.length));
            element.addEventListener('click', e => clickToChangePosition(e, element, slider));
        })
    }, 50)

    function cursorPosition(e, element, slider, index, amount) {
        var rect = e.target.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        let arrow = element.getElementsByClassName('arrow')[0];
        arrow.style.left = `${x}px`;
        arrow.style.top = `${y}px`;
        if (x > element.clientWidth / 2) {
            arrow.classList.remove('left')
            arrow.classList.add('right')
            if ((index + 1) == amount) {
                arrow.classList.add('disabled')
            } else {
                arrow.classList.remove('disabled')
            }
        } else {
            arrow.classList.remove('right')
            arrow.classList.add('left')

            if (index == 0) {
                arrow.classList.add('disabled')
            } else {
                arrow.classList.remove('disabled')
            }
        }

    }

    function clickToChangePosition(e, element, slider) {
        console.log('clicked')
        var rect = e.target.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        if (x > element.clientWidth / 2) {
            slider.goTo('next');
        } else {
            slider.goTo('prev');
        }
    }
}

export const stop = async function() {
    var slider = sliders;
    if (slider.destroy) {
        await slider.destroy();
    }
    return true;
}
